const updateImageCropAspectRatio = (state, { payload }) => {
	state.imageCropAspectRatio = payload;
};

export default updateImageCropAspectRatio;

